import { Component, Vue } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';

@Component({
  name: 'TombolaModalLayoutComponent'
})
export default class TombolaModalLayoutComponent extends TombolaBaseComponent {
  private layoutButtonsVisible: boolean = false;

  private get allWindowsMinimised(): boolean {
    return this.$modalManager.allModalsMinimised();
  }

  private toggleLayoutButtons() {
    this.layoutButtonsVisible ? this.hideLayoutButtons() : this.showLayoutButtons();
  }

  private showLayoutButtons() {
    this.layoutButtonsVisible = true;
  }

  private hideLayoutButtons() {
    this.layoutButtonsVisible = false;
  }

  private arrangeWindows() {
    this.$modalManager.restoreAllModals();
    Vue.nextTick(() => {
      this.$modalManager.arrangeAllModals();
      this.hideLayoutButtons();
    });
  }

  private tileWindows() {
    this.$modalManager.restoreAllModals();
    Vue.nextTick(() => {
      this.$modalManager.tileAllModals();
      this.hideLayoutButtons();
    });
  }

  private restoreWindows() {
    if (this.allWindowsMinimised) {
      this.$modalManager.restoreAllModals();
    }
    else {
      this.$modalManager.minimiseAllModals();
    }
    this.hideLayoutButtons();
  }

  private get restoreWindowsTooltipText(): string {
    if (this.allWindowsMinimised) {
      return this.$lang.app.workbench.layout.restore;
    }
    return this.$lang.app.workbench.layout.minimise;
  }

  private get restoreWindowsIconClass(): string {
    if (this.allWindowsMinimised) {
      return 'fa-window-maximize';
    }
    return 'fa-window-minimize';
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/home/_components/tombola-modal-layout/tombola-modal-layout.component.ts